import iconSquare from '@/assets/brand/icon-square.jpeg'
import styles from './ChatHeader.module.css'

export function ChatHeader() {
  return (
    <div className={styles.root}>
      <img src={iconSquare} alt="" className={styles.avatar} />
      <div className={styles.copy}>
        <span className={styles.name}>Security Investigation Orchestrator</span>
        <span className={styles.role}>Read-only investigation &amp; advisory</span>
      </div>
    </div>
  )
}
